import { integer } from "drizzle-orm/pg-core"
import {
  pgTable,
  serial,
  varchar,
  timestamp,
} from "drizzle-orm/pg-core"
import { relations } from "drizzle-orm"
import { text } from "drizzle-orm/pg-core"
import { chatsTable } from "./Chats"

export enum CHAT_MESSAGE_STATUS {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR"
}

export const chatsMessagesTable = pgTable("ChatsMessages", {
  id: serial().primaryKey(),
  creationTimestamp: timestamp({ withTimezone: true }).notNull().defaultNow(),
  prompt: text().notNull(),
  response: text(),
  error: text(),
  chatId: integer().notNull().references(() => chatsTable.id, { onDelete: "cascade" }),
  status: varchar({ length: 255 }).notNull().$type<CHAT_MESSAGE_STATUS>(),
  payload: text(),

  inputToken: integer(),
  outputToken: integer(),
})

export const chatsMessagesRelations = relations(
  chatsMessagesTable,
  ({ one }) => ({
    chat: one(chatsTable, {
      fields: [chatsMessagesTable.chatId],
      references: [chatsTable.id],
    }),
  }),
)

export type ChatMessageSchema = typeof chatsMessagesTable.$inferSelect
export type NewChatMessageSchema = typeof chatsMessagesTable.$inferInsert
